var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHauler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 131,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.995 33.82h71.863c6.242 0 11.303 4.572 11.303 10.211V81.9h27.497v-37.87c0-5.639 5.061-10.21 11.304-10.21h69.815c6.243 0 11.304 4.571 11.304 10.21v49.44c0 5.64-5.061 10.211-11.304 10.211h-69.816c-5.129 0-9.458-3.087-10.84-7.316h-28.424c-1.382 4.229-5.71 7.316-10.84 7.316H25.996c-6.243 0-11.304-4.571-11.304-10.21V44.03c0-5.638 5.06-10.21 11.304-10.21Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.277 86.007H195.71V3.665H72.397L56.278 23.296v62.711Z",
    fill: "#507EC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.711 86.008h6.18V1.75h-6.18v84.257Z",
    fill: "#799CD1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.429 3.665v79.654h-34.122V3.665h-2.284v79.654h-34.118V3.665h-2.637v79.654H86.147V3.665h-2.284v79.654H54.488v1.792h29.375v.896h2.284v-.896h34.121v.896h2.637v-.896h34.121v.896h2.284v-.896h34.121v.896h2.283V3.665h-2.285Z",
    fill: "#5380C4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.309 86.008h6.179V1.75h-6.179v84.257ZM86.016 86.008h6.18V1.75h-6.18v84.257ZM122.551 86.008h6.179V1.75h-6.179v84.257Z",
    fill: "#799CD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.465 92.1h-37.01L5.41 49.992l25.556-38.534 41.433-7.794-7.965 58.719-15.97 29.715Z",
    fill: "#507EC3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.968 3.665h-2.566L47.57 90.195l2.284.583 21.92-68.332 3.194-18.781Z",
    fill: "#5380C4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m49.852 90.621 6 1.478L82.017 1.48l-6-1.479-26.166 90.621Z",
    fill: "#799CD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 92.1h196.907v-6.988H6.551V92.1Z",
    fill: "#799CD1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.457 85.111H6.551v1.792h196.906v-1.792Z",
    fill: "#5380C4",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.48 51.33-.046-.378 22.448-34.988 32.11-5.082-20.019 69.911H15.087L11.48 51.331Zm51.564-37.838L35.15 17.906 13.626 51.453l3.333 27.224h27.417l18.668-65.185Z",
    fill: "#5380C4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.349 109.965h-31.285a6.296 6.296 0 0 1-5.821-3.888 6.293 6.293 0 0 1 1.366-6.866 6.3 6.3 0 0 1 4.455-1.844h31.286a6.298 6.298 0 0 1 6.298 6.298 6.299 6.299 0 0 1-6.299 6.3Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.86 110.402a.666.666 0 0 1-.475-.196.696.696 0 0 1-.146-.218.689.689 0 0 1-.051-.257V92.099h1.343v17.632a.671.671 0 0 1-.671.671ZM154.067 110.402a.666.666 0 0 1-.475-.196.68.68 0 0 1-.197-.475V92.099h1.343v17.632a.671.671 0 0 1-.671.671Z",
    fill: "#96CD61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.099 94.77H1.335a1.335 1.335 0 1 1 0-2.67h13.763a1.335 1.335 0 0 1 1.336 1.335 1.335 1.335 0 0 1-1.335 1.334Z",
    fill: "#1A1A1A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.429 31.403h-50.722a9.132 9.132 0 0 0-9.133 9.136v58.059h81.228V74.502l-14.147-38.074a7.71 7.71 0 0 0-7.226-5.025Z",
    fill: "#5CB30B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.862 42.653s8.502 46.149 52.358 44.25l.168 7.105-.168 1.714-.705 1.209-.907.907-1.36.609-.656.08-3.106.07h-10.948s-13.266-.02-13.333.014c-.067.034-4.954 0-4.954 0l-16.54-10.65.151-45.308Z",
    fill: "#8DC955",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.803 90.571h1.881V74.502h-1.881v16.07Z",
    fill: "#8DC955"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.559 94.427V42.655a4.325 4.325 0 0 1 4.322-4.324h34.578a4.341 4.341 0 0 1 4.05 2.812l9.739 26.094c.181.483.273.996.273 1.512v25.678a4.33 4.33 0 0 1-4.323 4.324h-44.317a4.327 4.327 0 0 1-4.322-4.325Zm4.322-55.793a4.023 4.023 0 0 0-4.02 4.021v51.772a4.024 4.024 0 0 0 4.02 4.021h44.317a4.027 4.027 0 0 0 4.021-4.021V68.749c0-.48-.086-.957-.255-1.407l-9.739-26.094a4.038 4.038 0 0 0-3.766-2.615h-34.578Z",
    fill: "#2B2B2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M291.686 89.407V75.666a1.876 1.876 0 0 1 1.737 1.16c.095.228.143.473.143.72v9.98a1.883 1.883 0 0 1-1.88 1.881Z",
    fill: "#799CD1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m272.042 64.878-8.059-22.79a2.337 2.337 0 0 0-2.203-1.56h-33.315a2.34 2.34 0 0 0-2.336 2.34v22.79a2.327 2.327 0 0 0 .684 1.652 2.331 2.331 0 0 0 1.652.685h41.376a2.342 2.342 0 0 0 2.312-2.018c.051-.37.013-.747-.111-1.1Z",
    fill: "#2B2B2B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M294.639 104.284c0 3.139-2.154 5.685-4.812 5.685h-81.253V98.601h81.253c2.657-.004 4.812 2.541 4.812 5.683Z",
    fill: "#5CB30B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M287.382 67.994h-3.134l-9.116-24.522a2.191 2.191 0 0 1 .254-2.005 2.186 2.186 0 0 1 1.791-.938l10.205 27.465Z",
    fill: "#2B2B2B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M238.037 69.386h1.611V39.139h-1.611v30.247Z",
    fill: "#8DC955"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.827 98.598c2.657 0 4.811 2.544 4.811 5.684a6.88 6.88 0 0 1-.038.688c-.288-2.814-2.313-4.996-4.773-4.996h-81.253v-1.376h81.253Z",
    fill: "#8DC955",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.133 72.373h-10.94a.846.846 0 0 1-.844-.844.845.845 0 0 1 .844-.844h10.939a.844.844 0 0 1 .845.844.842.842 0 0 1-.844.844Z",
    fill: "#1A1A1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m255.888 40.53 9.454 27.464h-7.739l-9.751-27.465h8.036ZM244.826 40.53l9.832 27.464h-3.051l-9.24-27.465h2.459Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.738 109.964H95.904s-1.865-3.325-1.104-3.459c.761-.134 4.79-9.995 4.79-9.995l9.539-7.104 10.478-2.504 9.538 2.504 7.128 5.139 4.425 5.512 2.284 8.197-1.244 1.71Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.778 110.966a1.047 1.047 0 0 1-.721-.291 1.05 1.05 0 0 1-.319-.71 22.936 22.936 0 0 0-22.917-21.938 22.938 22.938 0 0 0-22.917 21.938 1.043 1.043 0 0 1-2.02.323 1.048 1.048 0 0 1-.067-.414 25.027 25.027 0 0 1 25.006-23.941 25.026 25.026 0 0 1 25.006 23.941 1.044 1.044 0 0 1-.291.769 1.058 1.058 0 0 1-.756.323h-.004Z",
    fill: "#104FAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.86 110.404a19.954 19.954 0 0 0 12.326 18.436 19.957 19.957 0 0 0 21.75-4.331 19.962 19.962 0 0 0-3.028-30.708 19.96 19.96 0 0 0-31.049 16.603Z",
    fill: "#000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 110.463c.033-7.673-6.159-13.918-13.829-13.95-7.67-.033-13.914 6.16-13.946 13.832-.033 7.673 6.159 13.919 13.829 13.951 7.67.032 13.914-6.161 13.946-13.833Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.073 98.871a13.89 13.89 0 0 0 19.523 18.89 13.897 13.897 0 0 1-10.092 6.425 13.89 13.89 0 0 1-9.431-25.315Z",
    fill: "#C8D6EC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M109.531 110.404a9.29 9.29 0 0 0 15.857 6.563 9.29 9.29 0 0 0-1.409-14.289 9.293 9.293 0 0 0-8.715-.857 9.278 9.278 0 0 0-5.026 5.028 9.286 9.286 0 0 0-.707 3.555Z",
    fill: "#5C87C8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.692 102.659a9.291 9.291 0 0 0 1.17 11.702 9.288 9.288 0 0 0 11.702 1.174 9.284 9.284 0 0 1-6.815 4.108 9.297 9.297 0 0 1-9.674-6.122 9.284 9.284 0 0 1 .795-7.917 9.284 9.284 0 0 1 2.822-2.945Z",
    fill: "#5C87C8",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M86.168 109.964H40.333s-1.865-3.325-1.103-3.459c.76-.134 4.79-9.995 4.79-9.995l9.538-7.104 10.479-2.504 9.538 2.504 7.128 5.139 4.424 5.512 2.284 8.197-1.243 1.71Z",
    fill: "#1A1A1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.208 110.966a1.043 1.043 0 0 1-1.04-1.001 22.938 22.938 0 0 0-45.834 0 1.042 1.042 0 0 1-2.02.323 1.046 1.046 0 0 1-.067-.414 25.029 25.029 0 0 1 50.011 0 1.048 1.048 0 0 1-1.046 1.092h-.004Z",
    fill: "#104FAD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.29 110.404a19.962 19.962 0 0 0 23.857 19.569 19.958 19.958 0 0 0 7.19-36.172 19.96 19.96 0 0 0-31.048 16.603Z",
    fill: "#000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.137 110.463c.032-7.673-6.159-13.918-13.829-13.95-7.67-.033-13.913 6.161-13.945 13.833-.032 7.673 6.16 13.918 13.829 13.95 7.67.033 13.913-6.161 13.945-13.833Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.502 98.871a13.89 13.89 0 0 0 19.524 18.89 13.896 13.896 0 0 1-10.093 6.425 13.881 13.881 0 0 1-11.342-3.805 13.886 13.886 0 0 1-2.299-17.05 13.89 13.89 0 0 1 4.21-4.46Z",
    fill: "#C8D6EC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.96 110.404a9.288 9.288 0 1 0 18.577-.007 9.288 9.288 0 0 0-18.576.007Z",
    fill: "#5C87C8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.122 102.659a9.288 9.288 0 0 0 12.871 12.876 9.283 9.283 0 0 1-6.815 4.108 9.297 9.297 0 0 1-9.674-6.122 9.286 9.286 0 0 1 3.618-10.862Z",
    fill: "#5C87C8",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M255.512 109.964h-45.835s-1.865-3.325-1.104-3.459c.761-.134 4.791-9.995 4.791-9.995l9.538-7.104 10.478-2.504 9.538 2.504 7.128 5.139 4.425 5.512 2.284 8.197-1.243 1.71Z",
    fill: "#1A1A1A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M212.633 110.404a19.96 19.96 0 1 0 39.919-.011 19.96 19.96 0 0 0-39.919.011Z",
    fill: "#000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M246.481 110.462c.032-7.673-6.16-13.918-13.83-13.95-7.67-.032-13.913 6.162-13.945 13.834-.032 7.673 6.16 13.918 13.83 13.95 7.669.032 13.913-6.162 13.945-13.834Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M224.846 98.871a13.889 13.889 0 0 0 19.524 18.89 13.886 13.886 0 0 1-21.436 2.62 13.896 13.896 0 0 1-4.176-11.211 13.892 13.892 0 0 1 6.088-10.299Z",
    fill: "#C8D6EC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M223.305 110.404a9.289 9.289 0 1 0 18.577-.005 9.289 9.289 0 0 0-18.577.005Z",
    fill: "#5C87C8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.461 102.659a9.291 9.291 0 0 0 1.17 11.702 9.29 9.29 0 0 0 11.702 1.174 9.279 9.279 0 0 1-6.815 4.108 9.297 9.297 0 0 1-9.674-6.122 9.291 9.291 0 0 1 3.617-10.862Z",
    fill: "#5C87C8",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M256.552 110.966a1.043 1.043 0 0 1-1.04-1.001 22.937 22.937 0 0 0-22.917-21.938 22.94 22.94 0 0 0-22.918 21.938 1.04 1.04 0 0 1-1.04 1.001 1.056 1.056 0 0 1-.756-.323 1.064 1.064 0 0 1-.224-.355 1.062 1.062 0 0 1-.066-.414 25.026 25.026 0 0 1 25.005-23.941 25.03 25.03 0 0 1 25.006 23.941 1.044 1.044 0 0 1-.291.769 1.048 1.048 0 0 1-.756.323h-.003Z",
    fill: "#4274BF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHauler);
export default __webpack_public_path__ + "static/media/hauler.28cdccb05c03ade6a009a87af077ee70.svg";
export { ForwardRef as ReactComponent };